import React from "react";
import { Rss, Globe } from "lucide-react";

export const SOURCE_ICONS: Record<string, React.ReactNode> = {
  RSS: React.createElement(Rss, { className: "w-4 h-4 text-orange-400" }),
  rss: React.createElement(Rss, { className: "w-4 h-4 text-orange-400" }),
  SITEMAP: React.createElement(Globe, { className: "w-4 h-4 text-blue-400" }),
  sitemap: React.createElement(Globe, { className: "w-4 h-4 text-blue-400" }),
  HTML: React.createElement(Globe, { className: "w-4 h-4 text-green-400" }),
  html: React.createElement(Globe, { className: "w-4 h-4 text-green-400" }),
  HTML_SCRAPE: React.createElement(Globe, { className: "w-4 h-4 text-green-400" }),
};

export const SOURCE_TYPE_LABELS: Record<string, string> = {
  RSS: "RSS Feed",
  rss: "RSS Feed",
  SITEMAP: "Sitemap",
  sitemap: "Sitemap",
  HTML: "HTML Scraping",
  html: "HTML Scraping",
  HTML_SCRAPE: "HTML Scraping",
};

export function getRelativeTime(dateStr: string | null | undefined): string {
  if (!dateStr) return "never";
  const now = new Date();
  const date = new Date(dateStr);
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  return `${Math.floor(diffHours / 24)}d ago`;
}

export const SCHEDULE_OPTIONS = [
  { value: 0, label: "None" },
  { value: 60, label: "Hourly" },
  { value: 360, label: "Every 6h" },
  { value: 1440, label: "Daily" },
  { value: 10080, label: "Weekly" },
] as const;

export function getScheduleLabel(minutes: number | undefined): string {
  const opt = SCHEDULE_OPTIONS.find((o) => o.value === minutes);
  return opt?.label ?? "None";
}
